import { render, staticRenderFns } from "./DxViewWorkOrderToolsTable.vue?vue&type=template&id=21a24a86&"
import script from "./DxViewWorkOrderToolsTable.vue?vue&type=script&lang=js&"
export * from "./DxViewWorkOrderToolsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports